/**
 * KMC Hospital Configuration
 * Centralized hospital branding and contact information for all reports and documents
 */

export const hospitalConfig = {
    name: 'KMC Hospital',
    fullName: 'KMC Hospital',
    tagline: 'Excellence in Healthcare',

    // Contact Information
    address: 'No. 5 Garko Road off Okitipupa Crescent, Phase IV, Kubwa, Abuja-FCT',
    phone: '+234 816 414 4914',
    email: 'info@kmchospital.com',

    // Banking Details
    bank: {
        accountName: 'KMC Hospital Project',
        accountNumber: '0025417974',
        bankName: 'Guaranty Trust Bank',
        branch: 'Gado Nasko Road Branch, Kubwa'
    },

    // Logo (relative to public folder)
    logo: '/KMCHospLogo-notext.png',

    // Currency
    currency: {
        code: 'NGN',
        symbol: '₦',
        locale: 'en-NG'
    },

    // Email Notification Settings
    emailNotifications: {
        enabled: true,
        fromName: 'KMC Hospital',
        supportEmail: 'info@kmchospital.com',
        patientPortalUrl: 'https://kmchospital.org',
        // Email types that are enabled
        types: {
            registration: true,
            paymentReceipt: true,
            invoiceNotification: true,
            labResults: true,
            prescriptionDispensed: true
        }
    },

    // Session Management & Workstation Security Policy
    sessionSecurity: {
        idleTimeoutMinutes: 60,             // 60-minute total idle timeout
        warningDurationSeconds: 60,         // 60-second warning modal countdown before lock
        lockTimeoutMinutes: 60,             // 60 minutes locked before hard automatic logout
        autoSaveDraftsOnLock: true,         // Auto-preserves clinical notes/drafts on lock
        continuousActivityGraceMinutes: 5  // No disruptive mid-shift logout if user is actively working
    }
};

export default hospitalConfig;
